import { render, staticRenderFns } from "./GestaoContratosOriginacaoSubEmpresa.vue?vue&type=template&id=66c4996d&lang=pug"
import script from "./GestaoContratosOriginacaoSubEmpresa.vue?vue&type=script&lang=js"
export * from "./GestaoContratosOriginacaoSubEmpresa.vue?vue&type=script&lang=js"
import style0 from "./GestaoContratosOriginacaoSubEmpresa.vue?vue&type=style&index=0&id=66c4996d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports